import gql from 'graphql-tag'

import { MapsCoordsFieldsFragment } from './coords'

export const MapsBoundsFieldsFragment = gql`
  fragment MapsBoundsFields on MapsBounds {
    northEast {
      ...MapsCoordsFields
    }
    southWest {
      ...MapsCoordsFields
    }
  }

  ${MapsCoordsFieldsFragment}
`
